@use './variables' as *;
@use '../../styles/abstracts' as *;

:host {
  vertical-align: $toggle-host-vertical-align;
}

.required-mark {
  color: $toggle-mark-required-color;
}

.toggle {
  display: $toggle-host-display;
  flex-direction: $toggle-flex-direction;
  color: $toggle-color;
  font-family: $toggle-font-family;

  &-wrapper {
    display: $toggle-wrapper-display;
    position: $toggle-wrapper-position;
    width: $toggle-wrapper-width;
    height: $toggle-wrapper-height;
    margin-top: $toggle-margin-top;
    margin-right: $toggle-margin-right;
    margin-bottom: $toggle-margin-bottom;
    margin-left: $toggle-margin-left;
    border-radius: $toggle-border-radius;
    box-shadow: $toggle-box-shadow;
  }
  
  &-label {
    display: $toggle-label-display;
    margin-top: $toggle-label-margin-top;
    margin-right: $toggle-label-margin-right;
    margin-bottom: $toggle-label-margin-bottom;
    margin-left: $toggle-label-margin-left;
    color: inherit;
    font-family: inherit;
  }

  &.error {
    color: $toggle-error-color;
    .toggle-button {
      border-color: $toggle-error-border-color;
    }
  }
  &.success {
    color:  $toggle-success-color;
    .toggle-button {
      border-color: $toggle-success-border-color;
    }
  }
  
  .status-text {
    display: block;
    margin-top: $toggle-status-text-margin-top;
    margin-right: $toggle-status-text-margin-right;
    margin-bottom: $toggle-status-text-margin-bottom;
    margin-left: $toggle-status-text-margin-left;
    color: inherit;
    font-family: inherit;
  }
}

.toggle-button {
  display: flex;
  justify-content: center;
  align-items: $toggle-button-align-items;
  width: 100%;
  min-height: $toggle-button-min-height;
  padding-top: $toggle-padding-top;
  padding-right: $toggle-padding-right;
  padding-bottom: $toggle-padding-bottom;
  padding-left: $toggle-padding-left;
  border-width: $toggle-border-width;
  border-style: $toggle-border-style;
  border-color: $toggle-border-color;
  border-radius: $toggle-border-radius;
  color: $toggle-color;
  font-weight: $toggle-font-weight;
  font-size: $toggle-font-size;
  line-height: $toggle-line-height;
  font-family: $toggle-font-family;
  cursor: pointer;
  background-color: $toggle-background-color;

  &:nth-child(odd) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right-width: 1px;
  }  
  
  &:nth-child(even) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-width: 1px;
  }  

  &:hover {
    color: $toggle-hover-color;
    background-color: $toggle-hover-background-color;
    border-color: $toggle-hover-border-color;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 $toggle-focus-outline-width $toggle-focus-outline-color;
    color: $toggle-focus-color;
    background-color: $toggle-focus-background-color;
    border-color: $toggle-focus-border-color;
  }

  &:active {
    color: $toggle-active-color;
    background-color: $toggle-active-background-color;
    border-color: $toggle-active-border-color;
  }

  &[disabled] {
    color: $toggle-disabled-color;
    background-color: $toggle-disabled-background-color;
    border-color: $toggle-disabled-border-color;
    cursor: default;
  }

  &-selected {
    color: $toggle-selected-color;
    background-color: $toggle-selected-background-color;
    border-color: $toggle-selected-border-color;

    &:hover, &:focus {
      color: $toggle-selected-color;
      background-color: $toggle-selected-background-color;
      border-color: $toggle-selected-border-color;
    }
   

    &[disabled] {
      color: $toggle-selected-disabled-color;
      background-color: $toggle-selected-disabled-background-color;
      border-color: $toggle-selected-disabled-border-color;
      cursor: default;
    }
  }
}



@media (max-width: $breakpoint-mobile) {
  .toggle {
    vertical-align: $mobile-toggle-host-vertical-align;
    width: $mobile-toggle-host-width;
  }

  .button {
    &-wrapper {
      margin-top: $mobile-toggle-margin-top;
      margin-left: $mobile-toggle-margin-left;
      margin-bottom: $mobile-toggle-margin-bottom;
      margin-right: $mobile-toggle-margin-right;
    }
  }
}
